/* eslint-disable */
// prettier-ignore
export default {
  pages: {
    key: 'title',
    data: [
      { title: 'Articoli', route: { name: 'catalogo-articoli-tutti' }, icon: 'BookOpenIcon', isBookmarked: true },
      { title: 'Anagrafica', route: { name: 'azienda-anagrafica' }, icon: 'UserIcon', isBookmarked: true },
      { title: 'Richieste in corso', route: { name: 'azienda-leads' }, icon: 'FileTextIcon', isBookmarked: false },
      { title: 'Ordini', route: { name: 'azienda-ordini' }, icon: 'BoxIcon', isBookmarked: true },
      
    ],
  },
  files: {
    key: 'file_name',
    data: [],
  },
  contacts: {
    key: 'name',
    data: [],
  },
}
/* eslint-enable */
